import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import { RequireAuth, RequireRole } from "./auth/guards";
import LoginPage from "./pages/Login";
import DashboardPage from "./pages/Dashboard";
import DictionaryPage from "./pages/Dictionary";
import DescriptiveReportPage from "./pages/DescriptiveReport";
import WeightingPage from "./pages/Weighting";
import CrosstabsPage from "./pages/Crosstabs";
import RegressionPage from "./pages/Regression";
import TimeseriesPage from "./pages/Timeseries";
import BootstrapPage from "./pages/Bootstrap";
import ReportsPage from "./pages/Reports";
import CodingPage from "./pages/Coding";
import OpenTextPage from "./pages/OpenText";
import GeoMapPage from "./pages/GeoMap";
import ExitPollPage from "./pages/ExitPoll";
import ConteoRapidoPage from "./pages/ConteoRapido";
import DatasetsPage from "./pages/Datasets";
import CambiarPasswordPage from "./pages/CambiarPassword";
import AdminUsersPage from "./pages/admin/Users";
import AdminPermissionsPage from "./pages/admin/Permissions";
import AdminConfiguracionPage from "./pages/admin/Configuracion";
import AdminPromptsPage from "./pages/admin/Prompts";
import AdminErroresPage from "./pages/admin/Errores";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/dictionary" element={<DictionaryPage />} />
        <Route path="/descriptive" element={<DescriptiveReportPage />} />
        <Route path="/mapa" element={<GeoMapPage />} />
        <Route path="/exit-poll" element={<ExitPollPage />} />
        <Route path="/conteo-rapido" element={<ConteoRapidoPage />} />
        <Route path="/datasets" element={<DatasetsPage />} />
        <Route path="/weighting" element={<WeightingPage />} />
        <Route path="/crosstabs" element={<CrosstabsPage />} />
        <Route path="/regression" element={<RegressionPage />} />
        <Route path="/timeseries" element={<TimeseriesPage />} />
        <Route path="/bootstrap" element={<BootstrapPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/coding" element={<CodingPage />} />
        <Route path="/open-text" element={<OpenTextPage />} />
        <Route path="/cambiar-password" element={<CambiarPasswordPage />} />
        <Route
          path="/admin/users"
          element={
            <RequireRole roles={["admin"]}>
              <AdminUsersPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/permissions"
          element={
            <RequireRole roles={["admin"]}>
              <AdminPermissionsPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/prompts"
          element={
            <RequireRole roles={["admin"]}>
              <AdminPromptsPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/errores"
          element={
            <RequireRole roles={["admin"]}>
              <AdminErroresPage />
            </RequireRole>
          }
        />
        <Route
          path="/admin/configuracion"
          element={
            <RequireRole roles={["admin"]}>
              <AdminConfiguracionPage />
            </RequireRole>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
